import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

export enum VbPaymentChangeDateDisplayMode {
  ActiveOnlyAnnual = 'activeOnlyAnnual',
  ActiveWithScheduled = 'activeWithScheduled',
  ActiveAnnualWithScheduled = 'activeAnnualWithScheduled',
  Scheduled = 'scheduled'
}

@Pipe({
  name: 'vbPaymentChangeFrequencyDateString'
})
export class VbPaymentChangeFrequencyDateStringPipe implements PipeTransform {
  transform(dateValue: string | number | null, mode: VbPaymentChangeDateDisplayMode, year?: number): string {
    if (!dateValue) {
      return '';
    }

    const date =
      typeof dateValue === 'number'
        ? moment()
            .year(year!)
            .month(dateValue - 1)
        : moment.utc(dateValue);

    switch (mode) {
      case VbPaymentChangeDateDisplayMode.ActiveOnlyAnnual:
        return date.format('MMMM') + $localize` payments`;
      case VbPaymentChangeDateDisplayMode.ActiveWithScheduled: {
        const lastPaymentDate = date.clone().subtract(1, 'month');
        return $localize`Last payment in ` + lastPaymentDate.format('MMMM YYYY');
      }
      case VbPaymentChangeDateDisplayMode.ActiveAnnualWithScheduled: {
        const lastPaymentDate = date.clone().year(year! - 1);
        return $localize`Last payment in ` + lastPaymentDate.format('MMMM YYYY');
      }
      case VbPaymentChangeDateDisplayMode.Scheduled:
        return $localize`Starting ` + date.format('MMMM YYYY');
    }
  }
}
